import { combineReducers } from 'redux';

import { cardMetaDataSlice } from '~/pages/CardSaga/cardMetaDataSlice';
import { actionCardSlice } from '~/pages/CardSaga/ActionCard/actionCardSlice';
import { adventureCardSlice } from '~/pages/CardSaga/AdventureCard/adventureCardSlice';
import { characterClassCardSlice } from '~/pages/CardSaga/CharacterClassCard/characterClassCardSlice';
import { powerCardSlice } from '~/pages/CardSaga/PowerCard/powerCardSlice';
import { upgradeCardSlice } from '~/pages/CardSaga/UpgradeCard/upgradeCardSlice';
import { biomeSlice } from '~/pages/CardSaga/Biome/biomeSlice';
import { keywordSlice } from '~/pages/CardSaga/Keyword/keywordSlice';
import { characterClassSKinSlice } from '../../pages/CardSaga/CharacterClassCard/components/CharacterClassSkin/characterClassSkinSlice';

export const cardSagaReducers = combineReducers({
    cardMetaData: cardMetaDataSlice.reducer,
    actionCard: actionCardSlice.reducer,
    adventureCard: adventureCardSlice.reducer,
    characterClassCard: characterClassCardSlice.reducer,
    powerCard: powerCardSlice.reducer,
    upgradeCard: upgradeCardSlice.reducer,
    biome: biomeSlice.reducer,
    keyword: keywordSlice.reducer,
    characterClassSkin: characterClassSKinSlice.reducer,
});
